/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import { CommandResult_Client } from "@graphql/helpers/types.graphql";
import { CommandResult } from "@graphql/groups/fragment.graphql";
import utils, { TClientType, TNonEmptyArray } from "@graphql/helpers/utils.graphql";

type TClientUpdateFunctions = {
  handleClientUpdate: CommandResult_Client;
};
export type TClientUpdateMutations = {
  client: TClientUpdateFunctions;
};
export const clientUpdate = (fields: TNonEmptyArray<TClientType>) => gql`
  mutation clientUpdate($client: ClientUpdateInputType!) {
    client {
      update(client: $client) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Client")}
`;
